import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DeleteIcon } from 'assets/materialIcons/materialIcons';
import Button from 'components/button/ActionButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';

const ItemHeader = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-right: 40px;
    z-index: 1;
`;

function RuleListItemHeader(props) {
    const { handleOnDelete, title, translate } = props;

    return (
        <ItemHeader>
            <div>{title}</div>

            <Button
                icon={ <DeleteIcon color={ theme.palette.redOrange }/> }
                onClick={ handleOnDelete }
                primary={ false }
                title={ translate('actions.delete') }
            />
        </ItemHeader>
    );
}

RuleListItemHeader.propTypes = {
    handleOnDelete: PropTypes.func,
    title: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default translate(RuleListItemHeader);



// WEBPACK FOOTER //
// ./src/pages/discounts/rules/RuleListItemHeader.js